(function ($) {
    $(document).on("ready", function () {
        $(".accordion .header")
            .on("click", function (e) {
                e.preventDefault();
                var $this = $(e.currentTarget);
                var $li = $this.parents("li");
                var $content = $li.children(".content");
                var currentlyActive = $li.hasClass("active");

                $(".accordion li.active")
                    .removeClass("active")
                    .children(".content").slideUp();

                if (currentlyActive) {
                    $li.removeClass("active");
                    $content.slideUp();
                }
                else {
                    $li.addClass("active");
                    $content.slideDown(400, function () {
                        $(window).trigger("thee.accordion.active", $this);
                    });
                }
            });
    });
})(jQuery);